// extracted by mini-css-extract-plugin
module.exports = {"choiceChipsRoot":"BnhOzqio"};